import { request } from '@/shared/api/request'

export const getXmlForRequest = (data) =>
    request({ url: `contract/persCard/xmlReq`, method: 'POST', data })
